import { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../context/Context";
import { DevicesList, MakeBackup, UpdateDevice } from "../../api/api";
import SuccessToast from "../toasts/SuccessToast";

const SetBridgeDeviceModal = ({ setSetBridgeDeviceModal, device }) => {
  const { setIsLoading, devices, setDevices } = useContext(Context);

  const [devicesList, setDevicesList] = useState([]);
  const [deviceSerial, setDeviceSerial] = useState(null);

  const modalName = useRef(null);
  const closeButton = useRef(null);

  useEffect(() => {
    setSetBridgeDeviceModal(modalName);
  }, []);

  useEffect(() => {
    if (device) {
      // setIsLoading(true);
      setDeviceSerial(device.bridge_device_serial);
      // DevicesList({
      //   fw_version: 15,
      //   is_bus: 0,
      // }).then(({ data }) => {
      //   setDevices(data.devices);
      //   setIsLoading(false);
      // });

      setDevicesList(
        devices.filter((d) => d.fw_version >= 15 && d.is_bus == 0)
      );
    }
  }, [device, devices]);

  const handleSubmit = () => {
    setIsLoading(true);
    UpdateDevice({
      device_id: device.id,
      bridge_device_serial: deviceSerial,
    }).then(({ data }) => {
      SuccessToast("درگاه اتصال با موفقیت تغییر یافت");
      setDevices((prev) => {
        return prev.map((d) => {
          if (d.id == device.id) {
            d.bridge_device_serial = deviceSerial;
          }
          return d;
        });
      });
      closeButton.current.click();
      setIsLoading(false);
    });
  };

  const renderDevices = () => {
    return devicesList.map((dev, index) => {
      return (
        <option
          value={dev.serial}
          key={index}
          selected={device.bridge_device_serial == dev.serial ? "selected" : ""}
        >
          {dev.serial} {dev.name ?? ''}
        </option>
      );
    });
  };

  return (
    // Modal
    <div
      className="modal fade"
      id="backupModal"
      tabIndex="-1"
      aria-labelledby="backupModalLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="backupModalLable">
              انتخاب دستگاه
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <select
              id="timerSelect"
              className="form-select w-100"
              data-style="btn-default"
              value={deviceSerial}
              onChange={(e) => setDeviceSerial(e.target.value)}
            >
              {renderDevices()}
            </select>
          </div>
          <div className="modal-footer">
            {/* <button
              type="button"
              className="btn btn-outline-success-app mb-2"
              data-bs-dismiss="modal"
            >
              انصراف
            </button> */}
            <button
              type="button"
              className="btn btn-success-app mb-2"
              onClick={handleSubmit}
            >
              تایید
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetBridgeDeviceModal;
